module.exports = __webpack_public_path__ + "img/free.05ec6864.png";